/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Faq_Free_AInputs */

const en_wc_faq_free_a = /** @type {(inputs: Wc_Faq_Free_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our guides and hosted browser editor are free to use, and no WordCraftApp account is required to read, download or try online. WordCraft itself is open-source software under the MIT or Apache-2.0 license.`)
};

/**
* | output |
* | --- |
* | "Our guides and hosted browser editor are free to use, and no WordCraftApp account is required to read, download or try online. WordCraft itself is open-sourc..." |
*
* @param {Wc_Faq_Free_AInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_faq_free_a = /** @type {((inputs?: Wc_Faq_Free_AInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Faq_Free_AInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_faq_free_a(inputs)
});
export { wc_faq_free_a as "wc.faq.free.a" }